export default __webpack_public_path__ + "static/media/ph-photo.706b2687.jpeg";